/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setupprofilenotready3Inputs */

const en_setupprofilenotready3 = /** @type {(inputs: Setupprofilenotready3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The profile is created and still being prepared. Pick it in the top left in a moment.`)
};

const de_setupprofilenotready3 = /** @type {(inputs: Setupprofilenotready3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Profil ist angelegt und wird gerade vorbereitet. Wähle es gleich oben links aus.`)
};

/**
* | output |
* | --- |
* | "The profile is created and still being prepared. Pick it in the top left in a moment." |
*
* @param {Setupprofilenotready3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setupprofilenotready3 = /** @type {((inputs?: Setupprofilenotready3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setupprofilenotready3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setupprofilenotready3(inputs)
	return de_setupprofilenotready3(inputs)
});
export { setupprofilenotready3 as "setupProfileNotReady" }